<div class="footer-holder">
        <div class="copyright">&copy; 2023 - INOBU AB</div>
</div>
